// extracted by mini-css-extract-plugin
module.exports = {"ProgramWrapper":"Program-module--ProgramWrapper--3EA18","TimeRow":"Program-module--TimeRow--gXRRW","Hyphen":"Program-module--Hyphen--2TthS"};